// Environment Configuration
export const envConfig = {
  // API Configuration
  API_URL: import.meta.env.VITE_API_URL || 'https://hermes.kutamma.com/v1',
};

// Validate required environment variables
export const validateEnv = () => {
  const required = ['VITE_API_URL'];
  const missing = required.filter(key => !import.meta.env[key]);
  
  if (missing.length > 0) {
    console.warn(`Missing environment variables: ${missing.join(', ')}`);
  }
};

// Export default configuration
export default envConfig; 